import React, { useState } from 'react';
import MaterialTable from 'material-table';
import { StockOrderStatusEnum, Status } from 'openapi';
import StatusColumn from '../labels/StatusColumn';
import OrderTypeChip from '../labels/OrderTypeChip';

interface Props {
    errorList: Status[],
}

export default ((props) => {
    return (
        <MaterialTable
            title="Error List"
            columns={[
                {
                    title: 'Order Type', field: 'orderType', editable: 'never',
                    render: data => <OrderTypeChip orderType={data ? data.orderType : -1} />,
                },
                { title: 'Created Date', field: 'createdDate', type: 'date' },
                {
                    title: 'Status', field: 'orderStatus', editable: 'never',
                    render: data => <StatusColumn status={data ? data.status : StockOrderStatusEnum.Waiting} />,
                },
                { title: 'Karte No', field: 'karteNo', type: 'numeric' },
                { title: 'Message Code', field: 'messageCode' },
                { title: 'Message', field: 'message' },
            ]}
            data={props.errorList}
            options={{
                search: false,
                sorting: false,
                filtering: false,
                paging: false
            }}
        />
    );
}) as React.FC<Props>;
